<template>
  <button :data-testid="dataTestid" class="flex gap-1 justify-center items-center text-base font-semibold">
    <Icon v-if="props.icon" :name="props.icon" size="base" />
    <span v-if="props.preLabel" class="text-black dark:text-zinc-300">{{ props.preLabel }}</span>
    <span class="text-blue-500">{{ props.label }}</span>
    <Icon name="general.menuArrow" size="base" class="text-blue-500" />
  </button>
</template>

<script lang="ts" setup>
import { Icon } from './../icon';

interface Props {
  icon?: string;
  preLabel?: string;
  label: string;
  dataTestid?: string;
}

const props = defineProps<Props>();
</script>
